import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

class Card extends PureComponent {
  render() {
    const {children, img, title, width, customClass, customTitleClass, customTextClass, customImgClass} = this.props;
    return (
      <div className={'card ' + customClass} style={{width}}>
        <img src={img} alt="card-img" className={'card-img ' + customImgClass} />
        <div className={'card-title ' + customTitleClass}>{title}</div>
        <div className={'card-text ' + customTextClass}>{children}</div>
      </div>
    );
  }
}

Card.defaultProps = {
  img: '',
  title: '',
  text: '',
  width: '31%',
  customClass: '',
  customTitleClass: '',
  customTextClass: '',
  customImgClass: '',
};

Card.propTypes = {
  img: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  width: PropTypes.any,
  customClass: PropTypes.string.isRequired,
  customTitleClass: PropTypes.string.isRequired,
  customTextClass: PropTypes.string.isRequired,
  customImgClass: PropTypes.string.isRequired,
};

export default Card;
